module.exports = __webpack_public_path__ + "img/tldz.8fb15d51.png";